
import _ from 'underscore';
import $ from 'jquery';
import vex from 'vex-js';
import '@selectize/selectize';
import 'parsleyjs';
import ParsleyConfig from './lib/ParsleyConfig';
import Cleave from 'cleave.js';

class Forms {

  constructor() {

    vex.defaultOptions.className = 'vex-theme-plain';

    let config = new ParsleyConfig;
    config.apply(Parsley);

    // Any popup form
    $('[data-popup]').click(event => {
      event.preventDefault();

      var $button = $(event.currentTarget);
      var $target = $button.data('action');

      // Check to see if we should be changing url
      let url = $button.data('popup-url');
      var old_url;

      if (url) {
        if (typeof history === 'object' && typeof history.pushState === 'function') {
          old_url = window.location.pathname; // save old for when modal closes
          history.pushState(null, '', url);
        }
      }

      if ($target) {
        var content = $('#' + $target).html();
        var privacy = $('#privacy').html();
        this.open( content, privacy, $button, $target, old_url );
      }
    });

    // With the following URL "/developments/register/karaka" scroll to element with this selector [data-uri="karaka"]
    let segments = window.location.pathname.toString().split( '/' );
    let target = _.indexOf(segments, 'register') + 1;
    var targetByName = segments[target];

    if (targetByName) {
      this.scrollToAndOpen('[data-uri="' + targetByName + '"]');
    }

    // Contact page is an embedded form. So it is manually added
    this.addContactUsForm();
  }

  scrollToAndOpen(selector, offset = 140) {

    let $target = $(selector);
    let $button = $target.find('[data-action="register"]');

    if ($target.length) {

      setTimeout(function () {
        $(window).scrollTop($target.offset().top - offset);
      }, 6);

      setTimeout(function () {
        $button.trigger('click');
      }, 1);
    }
  }

  open ( content, privacy, $button, $target, old_url ) {
    vex.open({
      content: content,
      overlayClosesOnClick: false,
      showCloseButton: false,
      appendLocation: '#app',
      afterOpen: $content => {
        var $form = $content.find('form');

        let $expandLink = $content.find('[data-expand]');

        $expandLink.on('click', event => {
          let privacyAlt  = $('#' + $expandLink.data('expand-target')).html();
          this.addPrivacy(privacyAlt || privacy);
        });

        let content = $content.find("select:not(.custom-select)").selectize({
            allowEmptyOption: true,
            onInitialize: function () {
                this.$control_input.attr("readonly", true);
            },
        });
        let houseInput = $content.find('input[name="interest"]');
        let houseTitle = $button.data('house');

        if( houseTitle === '' ){
          houseInput.parents('.field').eq(0).remove();
        } else {
          houseInput.val($button.data('house'));
        }

        let budgetFrom = $content.find('input[name="budgetfrom"]').get(0);
        let budgetTo = $content.find('input[name="budgetto"]').get(0);
        if (budgetFrom) {
          var cleave = new Cleave(budgetFrom, {
            prefix: '$',
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            noImmediatePrefix: true
          });
        }
        if (budgetTo) {
          var cleave = new Cleave(budgetTo, {
            prefix: '$',
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            noImmediatePrefix: true
          });
        }
        // if (budgetTo) {
        //   budgetTo.addEventListener("keypress", function (evt) {
        //     evt = (evt) ? evt : window.event;
        //     var charCode = (evt.which) ? evt.which : evt.keyCode;
        //     if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        //         evt.preventDefault();
        //     }
        //   });
        // }

        let developmentSelect = $content.find('select[name="DevelopmentID"]').get(0);

        if (developmentSelect) {
          developmentSelect.selectize.setValue($button.data('development'));
          developmentSelect.selectize.on('change', e => {
            window.dataLayer.push({
              'event'  : 'formSelectUpdate',
              'value': $(developmentSelect).text(),
              'formId' : $form.attr('id')
            });
          });
        }

        // set the initial affordable home options for the selected development
        let affordableHomes = $button.data('affordable-homes');
        if(affordableHomes) {
          let schemes = affordableHomes.toString().split(',');
          this.toggleAffordableHomes(schemes);
        } else {
          this.toggleAffordableHomes([]);
        }

        let detailsRegistration = $button.data('details');
        if (detailsRegistration) {
          this.prepopulateAffordableHomes($content);
          this.hideAffordableHomeText();
        }

        // update the possible affordable homes for the choosen development
        $('select[name="DevelopmentID"]').on('change', (e) => {
          $.ajax({
            url: '/home/affordable_homes',
            data: {
              'development-id' : parseInt(e.currentTarget.value)
            }
          }).done((response) => {
            this.toggleAffordableHomes(response);
          }).fail((response) => {
            // just hide them all :/
            this.toggleAffordableHomes([]);
          });
        });

        let firstPopupModal = document.querySelector(`[data-id='apartment-explorer-modal']`);
        $content.find('.vex-close').on('click', event=> {
          vex.close($content.data().vex.id);
        });

        if (typeof gtag !== 'undefined') {
        // if (typeof ga !== 'undefined') {
          // ga('send', 'event', 'Forms', 'popup', $form.attr('id'));
          gtag('event', 'popup', { 'event_category': 'Forms', 'event_label': $form.attr('id') });
        }

        if (typeof _cloudAmp !== 'undefined') {
          _cloudAmp.populateForm($form.get(0));
        }

        this.add($form);

      },
      afterClose: () => {
        if (typeof old_url !== 'undefined') {
          if (old_url.length > 0) {
            history.pushState(null, '', old_url);
          }
        }
      }
    });
  }

  addContactUsForm() {
    let $contactUsForm = $('section.contact').find('form');

    if ($contactUsForm.length > 0) {
      this.add($contactUsForm);

      $contactUsForm.find('[data-expand]').on('click', event => {
        let targetID = $(event.target).data('expand-target');
        let privacy = $(`#${targetID}`).html();

        this.addPrivacy(privacy);
      });
    }
  }

  addPrivacy(privacy) {
    vex.open({
      content: privacy,
      overlayClosesOnClick: false,
      showCloseButton: false,
      appendLocation: '#app',
      afterOpen: $content => {
        $content.find('.vex-close').on('click', event => {
          vex.close($content.data().vex.id);
        });
      }
    });
  }


  add($form, callback, rewriteURL = true) {

    this.active = $form;

    $form.parsley({
      inputs: Parsley.options.inputs + ',[data-parsley-check-children]',
      errorsContainer: function(pEle) {
        var $err = pEle.$element.parents('.field').find('.errors')
        return $err;
      },
      errorsWrapper: '<div></div>',
      errorTemplate: '<div class="pointing label"></div>'
    });

    $form.parsley().on('form:success', (instance) => {

      instance.submitEvent.preventDefault();

      if ( $form.parsley('validate') ) {

        $form.find('button.send').prop('disabled', true);
        $form.find('button.send').html(`<span></span>Sending`);

        //  Validates ok, send
        $.ajax({
          type : "POST",
          url  : $form.attr('action'),
          data : $form.serializeArray(),
          statusCode: {
            200: () => {
              // Google Tag Manager
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event'  : 'formSubmissionSuccess',
                'formId' : $form.attr('id')
              });

              // Google Analytic Events
              if (typeof ga !== 'undefined') {
                // ga('send', 'event', 'Forms', 'submit', $form.attr('id'));
                gtag('event', 'submit', { 'event_category': 'Forms', 'event_label': $form.attr('id') });
              }

              $form.parent().find("h4.thank-you-error").hide();
              $form.parent().find("h4.thank-you").show();

              if (rewriteURL && typeof history === 'object' && typeof history.pushState === 'function') {
                history.pushState(null, '', window.location.pathname + 'thank-you');
              }

              // scroll only modal to top so user can see message
              $('div.vex').scrollTop(0);

              //should close the modal after some time
              if (typeof callback == 'function') {
                callback($form);
              } else {
                $form.find('button.send').prop('disabled', false);
                $form.find('button.send').html(`<span></span>Submit`);
                $form.get(0).reset();
                $form.hide();
              }
            },
            500: () => {
              $form.parent().find("h4.thank-you-error").show("slow");
            }
          }
        });
      };

      $form.addClass('submitted');
    });
  }

  toggleAffordableHomes(schemes) {
    let wrapperSel = '#AffordableHomeSchemes';

    // hide, un-check and disable all inputs
    $(wrapperSel + ' li').hide();
    $(wrapperSel + ' input').prop('checked', false);
    $(wrapperSel + ' input').attr('disabled', 'disabled');

    // enable and show all available schemes
    for (let i = 0, l = schemes.length; i < l; i++) {
      let sel = schemes[i].replace(/ /g, '_');
      $(wrapperSel + ' .val' + sel).show();
      $(wrapperSel + ' .val' + sel + ' input').prop('checked', true);
      $(wrapperSel + ' .val' + sel + ' input').removeAttr('disabled');
    }

    if (!schemes.length) {
      $(wrapperSel).closest('.field').hide();
    } else {
      $(wrapperSel).closest('.field').show();
    }
  }

  prepopulateAffordableHomes($content) {
    let buyerTypeSelect = $content.find('select[id="buyer-type"]').get(0);
    let oneBedroomInput = $content.find('input[value="1 Bedroom"]').get(0);

    if (buyerTypeSelect) {
      buyerTypeSelect.selectize.setValue('First Home Buyer');
    }
    if (oneBedroomInput) {
      oneBedroomInput.setAttribute('checked', true);
    }

  }

  hideAffordableHomeText() {
    $('.affordable-home__text').addClass('hide');
  }
}

export { Forms as default };
